import Slider from 'react-slick';
import Image from 'next/image';
import { setCarouselConfig } from '../../../utils/carousel';

export default function CarouselMusic({ config, content }) {
    const settings = setCarouselConfig(config);

    return (
        <div className={`oCarouselChannels`}>
            <Slider {...settings}>
                {content.map((carouselItem) => (
                    <div key={carouselItem.id} className={`oCard ChannelCard`}>
                        <div className={`cardWrapper`}>
                            <div className={`oCardImage`}>
                                <figure className={`mImage`}>
                                    <Image
                                        src={carouselItem?.image?.data?.attributes?.url}
                                        alt={carouselItem?.image?.data?.attributes?.alternativeText}
                                        width={carouselItem?.image?.data?.attributes?.width}
                                        height={carouselItem?.image?.data?.attributes?.height}
                                        className={`aImage`}
                                        aria-hidden="true"
                                        layout="responsive"
                                    />
                                </figure>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            <style global jsx>{`
                .slick-slider {
                    max-width: 1920px;
                    margin: 0 auto;
                    overflow: hidden;
                }
                .oCarouselChannels .slick-track {
                    overflow: auto;
                    display: flex !important;
                    padding-top: 20px;
                }

                .oCarouselChannels .slick-slide > div {
                    height: 100%;
                }
                .slick-slide.slick-center {
                    transform: scale(1);
                    transition: 0.3s;
                }
                .slick-slider button {
                    position: absolute;
                }

                .slick-arrow {
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    border: 0;
                    background-color: transparent;
                    text-indent: 400px;
                    overflow: hidden;
                    width: 50px;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                .slick-arrow.slick-next {
                    right: 2%;
                    background-image: url('./images/icon-arrow-right.svg');
                }
                .slick-arrow.slick-prev {
                    left: 2%;
                    background-image: url('./images/icon-arrow-left.svg');
                }
                .oCarouselChannels .slick-dots li.slick-active {
                    background-color: #0ae6cc;
                }
                @media (max-width: 767px) {
                    .oCarouselChannels .slick-track {
                        overflow: visible;
                    }
                    .oCarouselChannels .slick-slide {
                        margin: 0 0;
                    }
                }
            `}</style>
        </div>
    );
}
